module.exports = __webpack_public_path__ + "static/media/check.ecd6ea3d.gif";